export const SET_HISTORY_LOCK_DATA = "SET_HISTORY_LOCK_DATA";